import { ROUTES } from 'src/router/const'

export const SETTINGS_TABS_LIST = [
  {
    key: 'account-details',
    label: 'Account Details',
    icon: 'user',
    route: ROUTES.SETTINGS_ACCOUNT_DETAILS,
  },
  {
    key: 'account-members',
    label: 'Account Members',
    icon: 'users',
    route: ROUTES.SETTINGS_ACCOUNT_MEMBERS,
  },
  {
    key: 'system-settings',
    label: 'System Settings',
    icon: 'settings',
    route: ROUTES.SETTINGS_SYSTEM_SETTINGS,
  },
]

export const SETTINGS_TABS = Object.fromEntries(SETTINGS_TABS_LIST.map((tab) => [tab.route, tab]))

export const EMAIL_PREFERENCE_ROWS = [
  {
    key: 'scanFailed',
    icon: 'alert-circle',
    label: 'Scan failed',
    description: 'An email will be sent when a scan of a site does not finish.',
  },
  {
    key: 'scanSuccess',
    icon: 'circle-check',
    label: 'Scan succeeded',
    description: 'An email will be sent when a site scan finishes successfully.',
  },
  {
    key: 'scanMonthly',
    icon: 'calendar-range',
    label: 'Monthly scan report',
    description: 'An email will be sent once a month with a summary of scan activity.',
  },
]

export const EMAIL_PREFERENCE_KEYS = EMAIL_PREFERENCE_ROWS.map((row) => row.key)

/** @type {import('src/services/consts/app.const').ConfirmToDeleteConfig} */
export const ACCOUNT_CONFIRM_TO_DELETE = {
  title: 'No longer using this account?',
  description:
    'If this account is no longer needed, you can permanently delete it and all associated data.',
  consequence: "You'll lose access to its settings, members, and data, and this cannot be undone.",
  buttonLabel: 'Delete account',
  confirmTitle: 'Delete account',
  confirmBody:
    'This will permanently delete your account and all associated data. This action is irreversible.',
  confirmLabel: 'Delete account',
  confirmNote:
    "You'll be signed out immediately, and all members will lose access to this account.",
  confirmPhrase: 'DELETE',
  inputId: 'delete-account-confirm-text',
}

/** @type {import('src/services/consts/app.const').ConfirmToDeleteConfig} */
export const ACCOUNT_CONFIRM_TO_LEAVE = {
  icon: 'logout',
  color: 'ochre',
  textClass: 'text-ochre',
  title: 'Leaving this account?',
  description:
    'By leaving your memebership will end, yet the account will remain for other members.',
  consequence: "You'll be signed out, and will no longer have access to this account.",
  buttonLabel: 'Leave account',
  confirmTitle: 'Leave account',
  confirmBody:
    'This will revoke your access to this account, yet the account and the data connected to it will remain active.',
  confirmLabel: 'Leave account',
  confirmNote:
    "If you're the only admin, promote someone else first, or delete the account instead.",
  confirmPhrase: 'LEAVE',
  inputId: 'leave-account-confirm-text',
}
